import { BaseRequest } from "../models/base-request.model";

export class Message {
    Id: any;
    BaseRequestId: any;
    ETenderId: any;
    SupplierId: any;
    SupplierCompanyName: any;
	Subject: string;
	Body: string;
	IsRead: boolean;
    CreatedBy: string;
    CreationDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
    ServiceNameAR: string;
    ServiceNameEN: string;
    RequestNumber: string;
    TenderNumber: string;
	MessageAttachments: MessageAttachments[];
    MessageReceivers: MessageReceivers[];
    //BaseRequest: BaseRequest

};

export class MessageReceivers{
    Id: any;
    SenderId: any;
    SenderAdminEmail: string;
    SenderSPGroupId: any;
    ReceiverId: any;
    ReceiverSPGroupId: any;
    MessageId: any;
    CreatedBy: string;
    CreationDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
}

export class MessageAttachments{
    Id: any = "";
    DocumentName : string = "";
    DocumentType : string = "";
    MessageId : any = "";
    CreatedBy: string = "";
    CreationDate: string= "";
    ModifiedBy: string = "";
    ModifiedDate: string = "";
    IsDeleted: boolean = false;
    name: string = "";
}
